import { Check } from "lucide-react";
import type { ComponentType } from "react";
import { STEPS } from "../constants";

type StepDefinition = {
  readonly label: string;
  readonly icon: ComponentType<{ className?: string }>;
};

interface AIModeStepperBarProps {
  currentStep: number;
  completedSteps: number[];
  steps?: readonly StepDefinition[];
}

export default function AIModeStepperBar({
  currentStep,
  completedSteps,
  steps: stepsProp,
}: AIModeStepperBarProps) {
  const steps = stepsProp ?? STEPS;
  return (
    <div className="flex items-center gap-0 w-full max-w-xl mx-auto">
      {steps.map((step, index) => {
        const isActive = index === currentStep;
        const isCompleted = completedSteps.includes(index);
        const isLast = index === steps.length - 1;

        return (
          <div key={step.label} className="flex items-center flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <div
                className="w-7 h-7 rounded-full flex items-center justify-center text-[11px] font-semibold transition-all duration-300 flex-shrink-0"
                style={
                  isActive
                    ? {
                        background: "#FFD900",
                        color: "#1A1814",
                        boxShadow: "0 0 0 4px rgba(255,217,0,0.15)",
                      }
                    : isCompleted
                      ? { background: "#1A1814", color: "white" }
                      : { background: "#F0EEEB", color: "#9E9A94" }
                }
              >
                {isCompleted ? (
                  <Check className="w-3.5 h-3.5" strokeWidth={2.5} />
                ) : (
                  String(index + 1).padStart(2, "0")
                )}
              </div>
              <span
                className="text-[11px] whitespace-nowrap hidden sm:block transition-colors"
                style={
                  isActive
                    ? { color: "#1A1814", fontWeight: 600 }
                    : isCompleted
                      ? { color: "#43403D", fontWeight: 500 }
                      : { color: "#9E9A94" }
                }
              >
                {step.label}
              </span>
            </div>

            {!isLast && (
              <div className="flex-1 min-w-[12px] mx-1.5">
                <div
                  className="h-[1.5px] rounded-full transition-all duration-500"
                  style={{
                    background: isCompleted
                      ? "linear-gradient(90deg, #1A1814, #43403D)"
                      : "#E8E6E3",
                  }}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
